/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accessdenied11Inputs */

const en_accessdenied11 = /** @type {(inputs: Accessdenied11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Denied`)
};

const de_accessdenied11 = /** @type {(inputs: Accessdenied11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff verweigert`)
};

/**
* | output |
* | --- |
* | "Access Denied" |
*
* @param {Accessdenied11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accessdenied11 = /** @type {((inputs?: Accessdenied11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accessdenied11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accessdenied11(inputs)
	return de_accessdenied11(inputs)
});
export { accessdenied11 as "accessDenied1" }